// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1lg7_","header":"PatientQuestionnaire_header__fsAdy","info":"PatientQuestionnaire_info__1aDdL"};